import SolidMeshManagerObj from './components/obj'

export default SolidMeshManagerObj
